import loadModuleOnElement from "../../utils/loadModuleOnElement";

const moduleLoader = () => import("./userBehaviorContent");

export default function loader(context) {
    loadModuleOnElement(".rm-user-behavior-script", moduleLoader, context);
    return context;
}